/** The login site's check of a sign-in code before it is sent, so a partial code sends no request. */
export class SignInCodeFormat {
    completeCodePattern = /^[0-9]{6}$/u;
    isComplete(code) {
        return this.completeCodePattern.test(code);
    }
}
//# sourceMappingURL=SignInCodeFormat.js.map